<template>
  <div
    v-if="show && highway"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ highway.sign_rte || highway.road_name || 'Highway' }}</h3>
          <p class="customer-popup-subtitle">{{ highway.class_desc || 'Highway Details' }}</p>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <div class="customer-popup-section">
          <div class="port-stats-table">
            <table>
              <tbody>
                <tr>
                  <th>Road Name</th>
                  <td>{{ highway.road_name || '-' }}</td>
                </tr>
                <tr>
                  <th>Class</th>
                  <td>{{ highway.class || '-' }}</td>
                </tr>
                <tr>
                  <th>Class Description</th>
                  <td>{{ highway.class_desc || '-' }}</td>
                </tr>
                <tr>
                  <th>Sign Route</th>
                  <td>{{ highway.sign_rte || '-' }}</td>
                </tr>
                <tr>
                  <th>Route Type</th>
                  <td>{{ highway.rte_type || '-' }}</td>
                </tr>
                <tr>
                  <th>Route Number</th>
                  <td>{{ highway.rte_number || '-' }}</td>
                </tr>
                <tr>
                  <th>State</th>
                  <td>{{ highway.state || '-' }}</td>
                </tr>
                <tr>
                  <th>State FIPS</th>
                  <td>{{ highway.stfips || '-' }}</td>
                </tr>
                <tr>
                  <th>County FIPS</th>
                  <td>{{ highway.ctfips || '-' }}</td>
                </tr>
                <tr>
                  <th>Urban Code</th>
                  <td>{{ highway.urban_code || '-' }}</td>
                </tr>
                <tr>
                  <th>Total Tons</th>
                  <td>{{ formatNumber(highway.TOT_Tons_1) }}</td>
                </tr>
                <tr>
                  <th>Route ID</th>
                  <td>{{ highway.OBJECTID || '-' }}</td>
                </tr>
                <tr>
                  <th>Length (Miles)</th>
                  <td>{{ formatLength(highway.GEOD_LEN) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HighwayPopup',
  
  props: {
    highway: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    },
    
    formatLength(miles) {
      if (!miles) return '-';
      const num = parseFloat(miles);
      if (isNaN(num)) return '-';
      return num.toFixed(2);
    },
    
    formatNumber(value) {
      if (!value) return '-';
      const num = parseFloat(value);
      if (isNaN(num)) return '-';
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>
